import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'helpers/GlobalHelper';
import Header from '../Header';
import Style from './EditAccount.module.scss';

const EditAccount = ({
  editEmail = '',
  editFirstName = '',
  editGenericError = '',
  editLastName = '',
  firstNameError = '',
  headerProps = {},
  language = {},
  lastNameError = '',
  onEditAccount = noop,
  onEditDeleteClick = noop,
  onFieldChange = noop,
}) => {
  const {
    profile_alphaOnlyErrorFirstName: firstNameAlphaErrorText,
    profile_alphaOnlyErrorLastName: lastNameAlphaErrorText,
    profile_firstnameInputPlaceholder: firstNamePlaceholder,
    profile_lastnameInputPlaceholder: lastNamePlaceholder,
    profileEdit_deleteAccountButton: deleteAccountButtonText,
    profileEdit_header: profileHeaderText,
    profileEdit_submitButton: submitButtonText,
    profileError_firstNameLength: firstNameLengthError,
    profileError_lastNameLength: lastNameLengthError,
  } = language || {};

  const LENGTH_ERROR = 'LENGTH_ERROR';
  const FORMAT_ERROR = 'FORMAT_ERROR';

  let firstNameErrorText;
  let lastNameErrorText;

  switch (firstNameError) {
    case FORMAT_ERROR:
      firstNameErrorText = firstNameAlphaErrorText;
      break;
    case LENGTH_ERROR:
      firstNameErrorText = firstNameLengthError;
      break;
    default:
  }

  switch (lastNameError) {
    case FORMAT_ERROR:
      lastNameErrorText = lastNameAlphaErrorText;
      break;
    case LENGTH_ERROR:
      lastNameErrorText = lastNameLengthError;
      break;
    default:
      break;
  }

  return (
    <main className={Style.EditAccount}>
      <Header {...headerProps} />
      <div className={Style.EditAccountContainer}>
        <h1>{profileHeaderText}</h1>
        <div className={Style.error}>
          {editGenericError}
          <div className={Style.error}>{firstNameErrorText}</div>
          <div className={Style.error}>{lastNameErrorText}</div>
        </div>
        <div className={Style.nameContainer}>
          <input
            className={Style.inputField}
            type="text"
            placeholder={firstNamePlaceholder}
            name="editFirstName"
            value={editFirstName}
            onChange={onFieldChange}
            required
            aria-label="First Name"
          />
          <input
            className={Style.inputField}
            type="text"
            name="editLastName"
            placeholder={lastNamePlaceholder}
            value={editLastName}
            onChange={onFieldChange}
            required
            aria-label="Last Name"
          />
        </div>
        <input
          className={Style.inputField}
          type="email"
          name="editEmail"
          placeholder="Email Address"
          value={editEmail}
          aria-label="Email"
          aria-disabled
          readOnly
        />
        <button className={Style.btnPrimary} onClick={onEditAccount}>
          {submitButtonText}
        </button>
        <button className={classnames(Style.deleteButton, Style.link)} onClick={onEditDeleteClick}>
          {deleteAccountButtonText}
        </button>
      </div>
    </main>
  );
};

export default EditAccount;

EditAccount.propTypes = {
  editEmail: PropTypes.string,
  editFirstName: PropTypes.string,
  editGenericError: PropTypes.string,
  editLastName: PropTypes.string,
  firstNameError: PropTypes.string,
  headerProps: PropTypes.shape({}).isRequired,
  language: PropTypes.shape({}).isRequired,
  lastNameError: PropTypes.string,
  onEditAccount: PropTypes.func,
  onEditAccountBackClick: PropTypes.func,
  onEditDeleteClick: PropTypes.func,
  onFieldChange: PropTypes.func,
};
